import firebase from 'firebase/app';
import 'firebase/firestore';
export function isTimestamp(value) {
    return typeof value === 'object' && value instanceof firebase.firestore.Timestamp;
}
export function isDocumentReference(value) {
    return typeof value === 'object' && value instanceof firebase.firestore.DocumentReference;
}
//# sourceMappingURL=DataValidation.js.map